import styled from 'styled-components';
import { useDashboardControls } from 'contexts/Dashboard/useDashboardControls';
import DatePicker, { DateRangeInput } from 'components/inputs/DatePicker';
import LabelWrap from 'components/inputs/LabelWrap';
import ContextMenu from 'components/ContextMenu';
import { useMemo } from 'react';
import Button from 'components/inputs/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

const ActionsWrapper = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  padding: 10px;
  gap: 10px;
`;

const DateSelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  gap: 5px;
  margin-left: 5px;
  white-space: nowrap;
  button {
    padding: 0 10px;
    height: 30px;
  }
`;

interface DateRangeOption {
  label: string;
  range: [Date, Date];
}

const HRSpeedingFilterBar = () => {
  const {
    dashboardState: { daterange },
    setSelectedDateRange,
  } = useDashboardControls();

  const dateRangeOptions: DateRangeOption[] = useMemo(
    () => [
      {
        label: 'Senaste 7 dagar',
        range: [
          new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
          new Date(),
        ],
      },
      {
        label: 'Innevarande månad',
        range: [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            0,
            23,
            59,
            59,
            999
          ),
        ],
      },
      {
        label: 'Förra månaden',
        range: [
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            0,
            23,
            59,
            59,
            999
          ),
        ],
      },
    ],
    []
  );

  return (
    <ActionsWrapper>
      <Actions>
        <DateSelectWrapper>
          <LabelWrap label="Datum">
            <DatePicker
              calendarStartDay={1}
              customInput={
                <DateRangeInput daterange={[daterange[0], daterange[1]]} />
              }
              selectsRange
              startDate={daterange[0]}
              endDate={daterange[1]}
              dateFormat="yyyy-MM-dd"
              locale="sv"
              onChange={setSelectedDateRange}
              populateHolidays
              shouldCloseOnSelect
              showYearDropdown
              showMonthDropdown
              showWeekNumbers
            />
          </LabelWrap>
          <ContextMenu
            options={dateRangeOptions.map((ro) => ({
              label: ro.label,
              range: ro.range,
              onClick: () => setSelectedDateRange(ro.range),
            }))}
          >
            <Button>
              {dateRangeOptions.find(
                (ro) =>
                  daterange[0] &&
                  daterange[1] &&
                  daterange[0].getTime() === ro.range[0].getTime() &&
                  daterange[1].getTime() === ro.range[1].getTime()
              )?.label ?? 'Frival'}{' '}
              <FontAwesomeIcon icon={faAngleDown} />
            </Button>
          </ContextMenu>
        </DateSelectWrapper>
      </Actions>
    </ActionsWrapper>
  );
};

export default HRSpeedingFilterBar;
